function Toaster() {
  return (
    <div className="toaster-wrapper">
      <div className="toaster">
        <div className="shine"></div>
        <div className="slot"></div>
        <div className="foot foot--1"></div>
        <div className="foot foot--2"></div>
        <div className="foot foot--3"></div>
        <div className="foot foot--4"></div>
      </div>
      <div className="bimbo"></div>
      <div className="bimbo"></div>
    </div>
  );
}

export default Toaster;
